// Search hits come from the user's own Slack token, so results already respect
// their channel membership. Author names, text, and channel names are
// untrusted: mrkdwn is parsed into elements, never injected as HTML.

import { isNumber, isString, isStringRecord } from "../utils/schemaUtils";

export interface SlackSearchMatch {
  ts: string;
  author: string;
  // Slack mrkdwn source.
  text: string;
  channelId: string;
  // Channel name without the leading '#'.
  channelName: string;
  permalink?: string;
}

export interface SlackSearchResultsPayload {
  type: "slack_search_results";
  query: string;
  totalResults: number;
  matches: SlackSearchMatch[];
  // Bare Slack user id → display name for `<@UID>` tokens in match text.
  mentions?: Record<string, string>;
}

const isSlackSearchMatch = (v: unknown): v is SlackSearchMatch => {
  if (!v || typeof v !== "object") return false;
  const r = v as Record<string, unknown>;
  return (
    isString(r.ts) &&
    isString(r.author) &&
    isString(r.text) &&
    isString(r.channelId) &&
    isString(r.channelName) &&
    (r.permalink === undefined || isString(r.permalink))
  );
};

export const parseSlackSearchResultsPayload = (v: unknown): SlackSearchResultsPayload | null => {
  if (!v || typeof v !== "object") return null;
  const r = v as Record<string, unknown>;
  if (r.type !== "slack_search_results") return null;
  if (!isString(r.query)) return null;
  if (!isNumber(r.totalResults)) return null;
  if (!Array.isArray(r.matches) || !r.matches.every(isSlackSearchMatch)) return null;
  if (r.mentions !== undefined && !isStringRecord(r.mentions)) return null;
  return {
    type: "slack_search_results",
    query: r.query,
    totalResults: r.totalResults,
    matches: r.matches,
    mentions: r.mentions,
  };
};
